import { ChevronDown } from 'lucide-react-native';
import { ReactNode } from 'react';

import {
  Select,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicator,
  SelectDragIndicatorWrapper,
  SelectIcon,
  SelectInput,
  SelectItem,
  SelectPortal,
  SelectScrollView,
  SelectTrigger,
} from '@/components/ui/select';
import { useColors } from '@/hooks/useColors';

export function FilterSortSelectInput({
  onValueChange,
  options,
  placeholder,
  selectedValue,
  value,
}: {
  onValueChange: (id: string) => void;
  options: ReactNode[];
  placeholder: string;
  selectedValue: string;
  value: string;
}) {
  const { theme } = useColors();

  return (
    <Select
      className="col-span-1 mb-0 min-h-[44px] w-full"
      onValueChange={onValueChange}
      selectedValue={selectedValue}>
      <SelectTrigger className="w-full items-center justify-between bg-background-0 p-2">
        <SelectInput style={{ color: theme.colors.text }} placeholder={placeholder} value={value} />
        <SelectIcon as={ChevronDown} />
      </SelectTrigger>
      <SelectPortal>
        <SelectBackdrop />
        <SelectContent className="max-h-[70vh] w-full">
          <SelectDragIndicatorWrapper>
            <SelectDragIndicator />
          </SelectDragIndicatorWrapper>
          <SelectScrollView>{options}</SelectScrollView>
        </SelectContent>
      </SelectPortal>
    </Select>
  );
}
